import React, { useState } from 'react';

import { Button, Form, Modal } from 'react-bootstrap';

import Agenda from '../../../../assets/svg/Agenda';
import Chrono from '../../../../assets/svg/Chrono';

const ValidateApointmentModal = (props: any) => {
  const [newValue, setNewValue] = useState(false);

  const handleClose = () => {
    setNewValue(props.data);
    props.setShow(false);
  };

  return (
    <Modal show={props.show} onHide={handleClose} className="m-0 p-0" centered>
      <Modal.Header className="w-100 m-0 p-0">
        <div className="rounded p-0 m-0 w-100 align-items-center text-center" style={{ backgroundColor: 'white' }}>
          <div
            className="rounded-top p-2 d-flex justify-content-start gap-2 align-items-center text-center position-relative"
            style={{ backgroundColor: '#641abf', color: 'white' }}
          >
            <div className="ms-2">
              <Agenda color="#FFFFFF" w="28" />
            </div>
            <div className="d-flex justify-content-between w-100">
              <p className="my-auto">
                {props.newDate.toLocaleDateString('fr-FR', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: '2-digit'
                })}
              </p>
              <p className="my-auto">{props.newTime}</p>
            </div>
          </div>
          <div className="d-flex justify-content-between p-4 pb-0 mb-0">
            <div className="d-flex flex-column justify-content-start text-start">
              {props.type === 'entrant' && <p className="text-appointment fw-bold">État des lieux d’entrée</p>}
              {(props.type === 'sortant' || props.type === 'entrant/sortant') && (
                <p className="text-appointment fw-bold">État des lieux de sortie</p>
              )}
              {props.type === 'diagnostic' && <p className="text-appointment fw-bold">Diagnostics immobiliers</p>}
              <p className="text-appointment">
                {props.property.address.street}, {props.property.address.zip} {props.property.address.city}
              </p>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Chrono />
              <p className="text-appointment fw-bold App-link">{props.duration}h</p>
            </div>
          </div>
        </div>
      </Modal.Header>
      <div className="d-flex justify-content-center mt-3 mb-3 ms-3">
        <Form.Check
          type={'radio'}
          label={
            <p className="text-appointment m-0 fw-bold">En confirmant ce rendez-vous, vous vous engagez à l’honorer.</p>
          }
          checked={newValue}
          onChange={() => setNewValue(!newValue)}
        />
      </div>
      <Button variant="success" className="mx-auto p-3 mb-3" disabled={!newValue} onClick={() => props.reserve()}>
        JE CONFIRME LE RENDEZ-VOUS
      </Button>
    </Modal>
  );
};

export default ValidateApointmentModal;
